import { Button } from '@highlight/ui'
import { Download } from 'lucide-react'
import { Announcement } from '.'

const REINSTALL_URL = 'https://highlightai.com'

/**
 * Shown only on the stranded Medal-signed macOS build. There is no dismiss:
 * the build receives no further updates, so the nag is the only path forward.
 */
export const ReinstallAnnouncement = () => {
  const onReinstall = () => {
    window.open(REINSTALL_URL, '_blank', 'noopener,noreferrer')
  }

  return (
    <Announcement.Container className="border-warning bg-warning/10">
      <div className="app:gap-1.5 flex flex-col gap-2">
        <Announcement.Title>
          <Download size={16} className="text-warning-subtle flex-shrink-0" />
          <span>Downloading a new version is required</span>
        </Announcement.Title>
        <Announcement.Description>
          Highlight is unable to update until you reinstall from the website.
        </Announcement.Description>
      </div>
      <Announcement.Actions>
        <Button variant="outline" size="sm" onClick={onReinstall}>
          Reinstall Highlight
        </Button>
      </Announcement.Actions>
    </Announcement.Container>
  )
}
